<template>
    <div>
      <v-alert dense outlined type="info" class="mb-4 text-caption">
        Horario de reservación (referencia): 10:40 a 20:40, bloques de 30 min. Límite para maestros: 2 h/día por escuela (4 bloques), sin traslapes entre escuelas ni dos servidores a la misma hora — la validación en tiempo real irá en el panel de reservación.
        Los días inhábiles o festivos se toman del módulo de Días festivos (no se configuran aquí).
      </v-alert>
  
      <v-expansion-panels v-model="panel" multiple>
        <!-- Consulta de reservaciones por rango -->
        <v-expansion-panel>
          <v-expansion-panel-header class="text-subtitle-2">
            Reservar clases (bloques fijos, una columna por servidor)
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <p class="text-caption grey--text mb-3">
              Los <strong>bloques de hora están predefinidos</strong> (30 min, de 10:40 a 20:40). Cada <strong>columna es un servidor</strong>
              (el texto del campo Servidor del salón). Cada celda te permite reservar y te muestra si ya está tomada.
              Las clases de grupo bloquean por salón cuando el servicio envía <code class="text-caption">id_salon</code> en cada fila de grupo; si no viene, el bloqueo aplica a todas las columnas.
            </p>
            <v-row class="mb-2">
              <v-col cols="12">
                <v-chip x-small class="mr-2 mb-1" color="primary" dark>Reservar clase</v-chip>
                <v-chip x-small class="mr-2 mb-1" color="light-green lighten-4" label>Clase reservada</v-chip>
                <v-chip x-small class="mb-1" color="grey lighten-2" label>Clase bloqueada</v-chip>
              </v-col>
            </v-row>
            <v-row align="end" class="mb-2">
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="fechaReservaDesde"
                  type="date"
                  label="Desde"
                  filled
                  dense
                  hide-details
                  rounded
                  @change="ajustarFechaReservaDesde"
                />
              </v-col>
              <v-col cols="auto">
                <v-btn color="primary" :loading="cargandoReservasRango" rounded small @click="consultarReservasRango">
                  <v-icon small left>mdi-magnify</v-icon>
                  Consultar
                </v-btn>
              </v-col>
              <v-col cols="auto">
                <v-btn
                  small
                  dark
                  color="green"
                  tile
                  :disabled="!filasReservasPlanas.length"
                  @click="exportExcel(filasReservasPlanas, 'Reservas_salones_' + etiquetaEscuela)"
                >
                  <v-icon small>mdi-microsoft-excel</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <p v-if="!salonesConServidorList.length" class="text-caption amber--text text--darken-2 mb-2">
              No hay salones con el campo «Servidor» cargado para esta escuela. Configúralo en la sección superior.
            </p>
            <div v-else-if="consultaReservasEjecutada && !cargandoReservasRango">
              <template v-if="diasEnRangoConsulta.length">
                <v-tabs v-model="tabDiaReserva" show-arrows class="mb-2">
                  <v-tab v-for="d in diasEnRangoConsulta" :key="'tab-' + d">{{ formatearFechaCorta(d) }}</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabDiaReserva">
                  <v-tab-item v-for="d in diasEnRangoConsulta" :key="'item-' + d">
                    <div class="overflow-x-auto">
                      <v-simple-table dense>
                        <thead>
                          <tr>
                            <th class="text-left bloque-col">Bloque</th>
                            <th
                              v-for="s in salonesConServidorList"
                              :key="'h-' + d + '-' + s.id_salon"
                              class="text-center text-caption salon-col"
                            >
                              {{ s.servidor }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="blk in bloquesPredefinidos" :key="'r-' + d + '-' + blk.label">
                            <td class="text-caption">{{ blk.label }}</td>
                            <td
                              v-for="s in salonesConServidorList"
                              :key="'c-' + d + '-' + s.id_salon + '-' + blk.inicio"
                              class="text-caption text-center"
                            >
                              <v-btn
                                v-if="estadoCelda(d, s.id_salon, blk) === 'disponible'"
                                x-small
                                rounded
                                color="primary"
                                class="teacher-reserva-chip text-none"
                                :loading="isGuardandoCelda(d, s.id_salon, blk)"
                                @click.stop="reservarCelda(d, s.id_salon, blk)"
                              >
                                Reservar clase
                              </v-btn>
                              <v-chip
                                v-else-if="estadoCelda(d, s.id_salon, blk) === 'mia'"
                                x-small
                                dense
                                label
                                color="light-green lighten-4"
                                class="black--text teacher-reserva-chip teacher-chip-click"
                                @click.stop="abrirDialogLinkZoom(d, s.id_salon, blk)"
                              >
                                Clase reservada
                              </v-chip>
                              <v-chip
                                v-else
                                x-small
                                dense
                                label
                                color="grey lighten-2"
                                class="black--text teacher-reserva-chip"
                              >
                                Clase bloqueada
                              </v-chip>
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </div>
                  </v-tab-item>
                </v-tabs-items>
              </template>
            </div>
            <v-progress-linear v-if="cargandoReservasRango" indeterminate color="primary" class="mt-2" />
            <p v-if="consultaReservasEjecutada && !cargandoReservasRango && !filasReservasPlanas.length && salonesConServidorList.length" class="text-caption grey--text mt-2">
              No hay reservaciones en el rango seleccionado (o el servicio aún no devuelve datos).
            </p>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
  
      <!-- Dialog link Zoom (clic en maestro en grilla de reservas) -->
      <v-dialog v-model="dialogLinkZoom" max-width="420px" @click:outside="dialogLinkZoom = false, reservaSeleccionada = null">
        <v-card>
          <v-card-title class="text-subtitle-2 py-2 pr-2">
            Link Zoom
            <v-spacer />
            <v-btn icon small aria-label="Cerrar" @click="dialogLinkZoom = false, reservaSeleccionada = null">
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pb-3 pt-0">
            <div class="text-caption grey--text">{{ linkZoomDialogo.maestro }}</div>
            <div v-if="linkZoomDialogo.salon" class="text-caption">{{ linkZoomDialogo.salon }}</div>
            <div class="text-caption mb-2">{{ linkZoomDialogo.fecha }} · {{ linkZoomDialogo.bloque }}</div>
            <v-textarea
              v-if="linkZoomDialogo.link_zoom"
              :value="linkZoomDialogo.link_zoom"
              readonly
              outlined
              dense
              auto-grow
              rows="2"
              hide-details
              class="text-caption"
            />
            <p v-else class="text-caption grey--text mb-0">No hay link Zoom configurado para este salón.</p>
            <v-btn
              v-if="linkZoomDialogo.link_zoom_url"
              small
              color="primary"
              class="mt-2"
              :href="linkZoomDialogo.link_zoom_url"
              target="_blank"
              rel="noopener noreferrer"
            >
              <v-icon small left>mdi-open-in-new</v-icon>
              Abrir en navegador
            </v-btn>
            <v-btn
              v-if="reservaSeleccionada && !cancelandoReservaSeleccionada"
              small
              color="error"
              outlined
              class="mt-2 ml-2"
              @click="cancelarReservaSeleccionada"
            >
              <v-icon small left>mdi-close-circle-outline</v-icon>
              Cancelar clase reservada
            </v-btn>
            <v-btn
              v-else-if="reservaSeleccionada && cancelandoReservaSeleccionada"
              small
              color="error"
              class="mt-2 ml-2"
              loading
              disabled
            >
              Cancelando...
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <Alerta v-if="respuestaAlerta" :parametros="parametros" />
      <carga v-if="cargar" />
    </div>
  </template>
  
  <script>
  import { mapGetters } from 'vuex'
  import Alerta from '@/components/alertas/Alerta.vue'
  import carga from '@/components/alertas/carga.vue'
  import validarErrores from '@/mixins/validarErrores'
  import funcionesExcel from '@/mixins/funcionesExcel'
  
  function pad2(n) {
    return n < 10 ? '0' + n : String(n)
  }
  
  /** Bloques de reservación predefinidos: 10:40–11:10 … 20:10–20:40 (30 min c/u). No se calculan en runtime salvo esta lista fija. */
  function generarBloques30Min() {
    const blocks = []
    let minutes = 10 * 60 + 40
    const maxStart = 20 * 60 + 10
    while (minutes <= maxStart) {
      const h1 = Math.floor(minutes / 60)
      const m1 = minutes % 60
      const minutesEnd = minutes + 30
      const h2 = Math.floor(minutesEnd / 60)
      const m2 = minutesEnd % 60
      const inicio = pad2(h1) + ':' + pad2(m1)
      const fin = pad2(h2) + ':' + pad2(m2)
      blocks.push({ inicio, fin, label: inicio + ' – ' + fin })
      minutes += 30
    }
    return blocks
  }
  
  function fechaHoyISO() {
    const d = new Date()
    return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate())
  }
  
  function fechaMasDiasISO(dias) {
    const d = new Date()
    d.setDate(d.getDate() + dias)
    return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate())
  }

function formatFechaYYYYMMDD(value) {
  if (!value) return ''
  const asString = String(value)
  if (/^\d{4}-\d{2}-\d{2}$/.test(asString)) return asString
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return asString.substring(0, 10)
  return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate())
}

/**
 * Normaliza a "HH:MM". El back suele usar `hora_fin`; el POST de reserva usa `hora_final`.
 * Acepta string, número u otros tipos (evita que horaAMinutos devuelva 0 por typeof).
 */
function normalizarHoraHHMM(value) {
  if (value == null || value === '') return ''
  if (typeof value === 'number' && !Number.isNaN(value)) {
    const s = String(Math.floor(value))
    if (s.length === 3 || s.length === 4) {
      const pad = s.length === 3 ? '0' + s : s
      return pad.substring(0, 2) + ':' + pad.substring(2, 4)
    }
  }
  const raw = String(value).trim()
  if (!raw) return ''
  if (/^\d{3,4}$/.test(raw)) {
    const pad = raw.length === 3 ? '0' + raw : raw
    return pad.substring(0, 2) + ':' + pad.substring(2, 4)
  }
  const m = raw.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?/)
  if (m) {
    const h = parseInt(m[1], 10)
    const min = parseInt(m[2], 10)
    if (!Number.isNaN(h) && !Number.isNaN(min)) {
      return pad2(h) + ':' + pad2(min)
    }
  }
  return raw.length >= 5 ? raw.substring(0, 5) : raw
}

/** Incluye `hora_final` (grupo_fechas / reservas) y `hora_fin` (ERP). */
function horaFinDesdeRow(row) {
  if (!row) return ''
  const keys = [
    'hora_final',
    'hora_fin',
    'hora_final_grupo',
    'hora_fin_grupo',
    'horaFin',
    'HoraFin',
    'Hora_final',
    'Hora_fin',
  ]
  for (let i = 0; i < keys.length; i++) {
    const n = normalizarHoraHHMM(row[keys[i]])
    if (n) return n
  }
  return ''
}

/** Fecha del grupo (el API puede usar distintos nombres de propiedad). */
function fechaDesdeRowGrupo(row) {
  if (!row) return ''
  const v =
    row.fecha != null && row.fecha !== ''
      ? row.fecha
      : row.Fecha != null && row.Fecha !== ''
        ? row.Fecha
        : row.fecha_dia != null && row.fecha_dia !== ''
          ? row.fecha_dia
          : row.fecha_grupo != null && row.fecha_grupo !== ''
            ? row.fecha_grupo
            : row.dia != null && row.dia !== ''
              ? row.dia
              : null
  return formatFechaYYYYMMDD(v)
}

function horaInicioDesdeRow(row) {
  if (!row) return ''
  const keys = [
    'hora_inicio',
    'hora_inicio_grupo',
    'hora_inicio_clase',
    'horaInicio',
    'HoraInicio',
    'Hora_inicio',
  ]
  for (let i = 0; i < keys.length; i++) {
    const n = normalizarHoraHHMM(row[keys[i]])
    if (n) return n
  }
  return ''
}

/** Tras mapear grupo_fechas, prioriza `hora_inicio` / `hora_final` ya normalizados en el objeto. */
function horaInicioEfectivaGrupo(g) {
  if (!g) return ''
  const s = g.hora_inicio != null && g.hora_inicio !== '' ? g.hora_inicio : horaInicioDesdeRow(g)
  return normalizarHoraHHMM(s)
}

function horaFinEfectivaGrupo(g) {
  if (!g) return ''
  const s =
    g.hora_final != null && g.hora_final !== ''
      ? g.hora_final
      : g.hora_fin != null && g.hora_fin !== ''
        ? g.hora_fin
        : horaFinDesdeRow(g)
  return normalizarHoraHHMM(s)
}

/** Asegura id de salón para filtrar / mapear (el API puede usar otro nombre). */
function idSalonDesdeRow(row) {
  if (!row) return null
  const v =
    row.id_salon != null
      ? row.id_salon
      : row.idSalon != null
        ? row.idSalon
        : row.salon_id != null
          ? row.salon_id
          : row.idsalon != null
            ? row.idsalon
            : null
  return v
}

/**
 * El API a veces manda grupo_fechas solo con fecha y horas en null o 00:00–00:00 (sin rango útil).
 * En ese caso se interpreta como “hay clase de grupo ese día” y se bloquean todos los bloques de la grilla.
 */
function grupoFechaBloqueaTodoElHorarioReserva(g) {
  const hi = horaInicioEfectivaGrupo(g)
  const hf = horaFinEfectivaGrupo(g)
  if (!hi && !hf) return true
  if (hi === '00:00' && hf === '00:00') return true
  return false
}

/** Une las variantes de nombre y niveles (a veces viene en `data`, `payload`, etc.). */
function extraerGrupoFechasDesdeResponse(data) {
  if (!data || typeof data !== 'object') return []
  const keys = [
    'grupo_fechas',
    'grupos_fecha',
    'grupo_fecha',
    'grupoFechas',
    'GrupoFechas',
    'gruposFecha',
  ]
  const contenedores = [data, data.data, data.payload, data.result].filter(
    (x) => x && typeof x === 'object'
  )
  const out = []
  for (let c = 0; c < contenedores.length; c++) {
    const obj = contenedores[c]
    for (let i = 0; i < keys.length; i++) {
      const arr = obj[keys[i]]
      if (!Array.isArray(arr)) continue
      for (let j = 0; j < arr.length; j++) {
        const item = arr[j]
        if (item && typeof item === 'object') out.push(item)
      }
    }
  }
  return out
}

/**
 * Rango del grupo [gs, ge] en minutos (24h) vs bloque [bs, be] (inicio/fin del bloque de 30 min).
 * Marca bloqueo si hay traslape, o si hora_inicio u hora_final caen dentro del bloque.
 */
function rangoGrupoIntersecBloque(gs, ge, bs, be) {
  if (ge <= gs) return false
  if (gs < be && ge > bs) return true
  if (ge > bs && ge <= be) return true
  if (gs >= bs && gs < be) return true
  return false
}

  export default {
    name: 'AdminEscuelaReservacion',
  
    components: { Alerta, carga },
  
    mixins: [validarErrores, funcionesExcel],
  
    props: {
      escuela: {
        type: Number,
        required: true,
        validator: (v) => v === 1 || v === 2,
      },
    },
  
    data: () => ({
      parametros: {
        dialogError: false,
        mensaje: '',
        color: '',
      },
      respuestaAlerta: false,
      cargar: false,
  
      panel: [0],
      salones: [],
  
      fechaReservaDesde: fechaHoyISO(),
      fechaReservaHasta: fechaHoyISO(),
      reservasRango: [],
      cargandoReservasRango: false,
      consultaReservasEjecutada: false,
      rangoReservasConsulta: { desde: null, hasta: null },
      tabDiaReserva: 0,
      bloquesPredefinidos: generarBloques30Min(),
  
      dialogLinkZoom: false,
      linkZoomDialogo: {
        maestro: '',
        link_zoom: '',
        link_zoom_url: '',
        salon: '',
        bloque: '',
        fecha: '',
      },
      celdasGuardando: {},
      festivos: [],
      grupoFechas: [],
      reservaSeleccionada: null,
      cancelandoReservaSeleccionada: false,
  
      
    }),
  
    computed: {
      ...mapGetters('login', ['getdatosUsuarioERPERP']),
  
      etiquetaEscuela() {
        return this.escuela === 1 ? 'INBI' : 'FAST'
      },
  
      salonesFiltrados() {
        const id_platel = this.escuela == 1 ? 17 : 16
        return this.salones.filter((s) => s.id_plantel == id_platel)
      },
  
      /** Salones de la escuela con campo servidor (texto) para la grilla de reservas */
      salonesConServidorList() {
        const idPlantel = this.escuela == 1 ? 17 : 16
        return this.salones.filter(
          (s) => s.id_plantel == idPlantel && String(s.servidor || '').trim() !== ''
        )
      },
  
      diasEnRangoConsulta() {
        if (!this.rangoReservasConsulta.desde || !this.rangoReservasConsulta.hasta) return []
        return this.enumerarDias(this.rangoReservasConsulta.desde, this.rangoReservasConsulta.hasta)
      },
  
      reservasRangoFiltradas() {
        const ids = {}
        for (let i = 0; i < this.salonesConServidorList.length; i++) {
          const id = this.salonesConServidorList[i].id_salon
          ids[id] = true
          ids[String(id)] = true
        }
        return this.reservasRango.filter((r) => {
          const id = idSalonDesdeRow(r)
          return id != null && (ids[id] || ids[String(id)])
        })
      },

      idTeacherActual() {
        const u = this.getdatosUsuarioERPERP || {}
        return u.id_usuario || u.iderp || null
      },

      misReservasRango() {
        if (!this.idTeacherActual) return []
        return this.reservasRangoFiltradas.filter((r) => this.esReservaMia(r))
      },
  
      filasReservasPlanas() {
        const rows = []
        const list = this.misReservasRango
        for (let i = 0; i < list.length; i++) {
          const r = list[i]
          rows.push({
            fecha: r.fecha,
            bloque: (horaInicioDesdeRow(r) || '') + ' – ' + (horaFinDesdeRow(r) || ''),
            salon: r.salon || '',
            servidor: r.servidor || '',
            maestro: r.maestro || r.nombre_maestro || r.teacher || r.nombre_teacher || '',
          })
        }
        return rows
      },

      fechasFestivasSet() {
        const map = {}
        for (let i = 0; i < this.festivos.length; i++) {
          const f = this.festivos[i].fecha
          if (f) map[f] = true
        }
        return map
      },

      /**
       * Bloqueos por grupo_fechas: clave fecha|id_salon|inicio_bloque (igual que reservas).
       * Si el registro trae id_salon, solo bloquea esa columna; si no, aplica a todos los salones con servidor.
       */
      bloqueosGrupoPorCeldaSet() {
        const map = {}
        const idsColumnas = this.salonesConServidorList.map((s) => s.id_salon)
        for (let i = 0; i < this.grupoFechas.length; i++) {
          const g = this.grupoFechas[i]
          if (!g || !g.fecha) continue
          const fecha = g.fecha
          const idGrupo = idSalonDesdeRow(g)
          const salonesDestino = idGrupo != null ? [idGrupo] : idsColumnas
          const marcar = (idSal, inicioBloque) => {
            map[fecha + '|' + String(idSal) + '|' + inicioBloque] = true
          }
          if (grupoFechaBloqueaTodoElHorarioReserva(g)) {
            for (let s = 0; s < salonesDestino.length; s++) {
              const idSal = salonesDestino[s]
              for (let j = 0; j < this.bloquesPredefinidos.length; j++) {
                marcar(idSal, this.bloquesPredefinidos[j].inicio)
              }
            }
            continue
          }
          const hi = horaInicioEfectivaGrupo(g)
          const hf = horaFinEfectivaGrupo(g)
          if (!hi || !hf) continue
          const gs = this.horaAMinutos(hi)
          const ge = this.horaAMinutos(hf)
          if (ge <= gs) continue
          for (let s = 0; s < salonesDestino.length; s++) {
            const idSal = salonesDestino[s]
            for (let j = 0; j < this.bloquesPredefinidos.length; j++) {
              const blk = this.bloquesPredefinidos[j]
              const bs = this.horaAMinutos(blk.inicio)
              const be = this.horaAMinutos(blk.fin)
              if (rangoGrupoIntersecBloque(gs, ge, bs, be)) {
                marcar(idSal, blk.inicio)
              }
            }
          }
        }
        return map
      },

      /** Mapa fecha|id_salon|hora_inicio_bloque => reserva */
      reservasPorCeldaMap() {
        const map = {}
        const list = this.reservasRangoFiltradas
        for (let i = 0; i < list.length; i++) {
          const r = list[i]
          if (!r || !r.fecha) continue
          const idSalon = idSalonDesdeRow(r)
          if (idSalon == null) continue
          const hi = horaInicioDesdeRow(r)
          const hf = horaFinDesdeRow(r)
          if (!hi || !hf) continue
          const rs = this.horaAMinutos(hi)
          const re = this.horaAMinutos(hf)
          for (let j = 0; j < this.bloquesPredefinidos.length; j++) {
            const blk = this.bloquesPredefinidos[j]
            const bs = this.horaAMinutos(blk.inicio)
            const be = this.horaAMinutos(blk.fin)
            if (rangoGrupoIntersecBloque(rs, re, bs, be)) {
              const k = r.fecha + '|' + String(idSalon) + '|' + blk.inicio
              if (!map[k]) map[k] = r
            }
          }
        }
        return map
      },
    },
  
    watch: {
      escuela: {
        immediate: true,
        async handler() {
          await this.cargarSalones()
          await this.cargarFestivos()
        },
      },
    },
  
    methods: {
      esFinSemanaFecha(fechaStr) {
        if (!fechaStr) return false
        const p = String(fechaStr).split('-')
        if (p.length !== 3) return false
        const d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10))
        const dia = d.getDay()
        return dia === 0 || dia === 6
      },

      siguienteDiaHabil(fechaStr) {
        if (!fechaStr) return fechaHoyISO()
        const p = String(fechaStr).split('-')
        if (p.length !== 3) return fechaHoyISO()
        const d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10))
        while (d.getDay() === 0 || d.getDay() === 6) {
          d.setDate(d.getDate() + 1)
        }
        return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate())
      },

      ajustarFechaReservaDesde() {
        if (!this.esFinSemanaFecha(this.fechaReservaDesde)) return
        this.fechaReservaDesde = this.siguienteDiaHabil(this.fechaReservaDesde)
        this.fechaReservaHasta = this.fechaReservaDesde
        this.validarErrorDirecto('Sábado y domingo no están disponibles para reservación.')
      },

      enumerarDias(desdeStr, hastaStr) {
        const out = []
        const a = desdeStr.split('-')
        const b = hastaStr.split('-')
        const start = new Date(parseInt(a[0], 10), parseInt(a[1], 10) - 1, parseInt(a[2], 10))
        const end = new Date(parseInt(b[0], 10), parseInt(b[1], 10) - 1, parseInt(b[2], 10))
        const cur = new Date(start.getTime())
        while (cur <= end) {
          out.push(
            cur.getFullYear() + '-' + pad2(cur.getMonth() + 1) + '-' + pad2(cur.getDate())
          )
          cur.setDate(cur.getDate() + 1)
        }
        return out
      },
  
      formatearFechaCorta(f) {
        const p = f.split('-')
        if (p.length !== 3) return f
        return pad2(parseInt(p[2], 10)) + '/' + pad2(parseInt(p[1], 10)) + '/' + p[0]
      },
  
      horaAMinutos(t) {
        const s = normalizarHoraHHMM(t)
        if (!s) return 0
        const p = s.split(':')
        const h = parseInt(p[0], 10) || 0
        const m = parseInt(p[1], 10) || 0
        return h * 60 + m
      },
  
      esReservaMia(r) {
        if (!r || !this.idTeacherActual) return false
        const id = r.id_teacher != null ? r.id_teacher : (r.id_usuario != null ? r.id_usuario : null)
        return String(id) === String(this.idTeacherActual)
      },

      esFechaFestiva(fecha) {
        return this.fechasFestivasSet[fecha] === true
      },

      esBloqueadoPorGrupoFecha(fecha, idSalon, blk) {
        return this.bloqueosGrupoPorCeldaSet[this.keyCelda(fecha, idSalon, blk)] === true
      },
  
      /** Registro de reserva que coincide con la celda, o null. */
      reservaEnCelda(fecha, idSalon, blk) {
        return this.reservasPorCeldaMap[this.keyCelda(fecha, idSalon, blk)] || null
      },

      estadoCelda(fecha, idSalon, blk) {
        if (this.esFechaFestiva(fecha)) return 'bloqueada'
        if (this.esBloqueadoPorGrupoFecha(fecha, idSalon, blk)) return 'bloqueada'
        const r = this.reservaEnCelda(fecha, idSalon, blk)
        if (!r) return 'disponible'
        return this.esReservaMia(r) ? 'mia' : 'bloqueada'
      },

      keyCelda(fecha, idSalon, blk) {
        return fecha + '|' + String(idSalon) + '|' + blk.inicio
      },

      isGuardandoCelda(fecha, idSalon, blk) {
        return this.celdasGuardando[this.keyCelda(fecha, idSalon, blk)] === true
      },

      async reservarCelda(fecha, idSalon, blk) {
        if (!this.idTeacherActual) {
          this.validarErrorDirecto('No se encontró tu identificador de teacher.')
          return
        }
        if (this.esFechaFestiva(fecha)) {
          this.validarErrorDirecto('No se puede reservar en día festivo.')
          return
        }
        if (this.esBloqueadoPorGrupoFecha(fecha, idSalon, blk)) {
          this.validarErrorDirecto('Este bloque está bloqueado por horario de clase.')
          return
        }
        if (this.estadoCelda(fecha, idSalon, blk) !== 'disponible') {
          this.validarErrorDirecto('Este bloque ya no está disponible.')
          return
        }
        const key = this.keyCelda(fecha, idSalon, blk)
        this.$set(this.celdasGuardando, key, true)
        const payload = {
          escuela: this.escuela,
          fecha: fecha,
          id_salon: idSalon,
          hora_inicio: blk.inicio,
          hora_final: blk.fin,
          hora_fin: blk.fin,
          id_teacher: this.idTeacherActual,
        }
        this.$http
          .post('teachersmode.post.reserva_salon', payload)
          .then(() => {
            this.consultarReservasRango()
          })
          .catch((error) => {
            this.validarError(error.response && error.response.data ? error.response.data.message : error)
          })
          .finally(() => {
            this.$set(this.celdasGuardando, key, false)
          })
      },
  
      abrirDialogLinkZoom(fecha, idSalon, blk) {
        const r = this.reservaEnCelda(fecha, idSalon, blk)
        if (r && !this.esReservaMia(r)) {
          return
        }
        const sal = this.salones.find(function (s) {
          return s.id_salon == idSalon || String(s.id_salon) === String(idSalon)
        })
        const link =
          (r && r.link_zoom) ||
          (sal && sal.link_zoom) ||
          ''
        const linkNormalizado = typeof link === 'string' ? link.trim() : ''
        const matchLink = linkNormalizado.match(/https?:\/\/[^\s]+/i)
        this.linkZoomDialogo = {
          maestro: (this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.nombre_completo) || 'Mi reservación',
          link_zoom: linkNormalizado,
          link_zoom_url: matchLink ? matchLink[0] : '',
          salon: (sal && sal.salon) || (r && r.salon) || '',
          bloque: blk.label,
          fecha: fecha,
        }
        this.reservaSeleccionada = r ? { ...r } : null
        this.dialogLinkZoom = true
      },

      idReservaDesdeRow(reserva) {
        if (!reserva) return null
        const keys = [
          'id_reserva_salon',
          'idreserva_salon',
          'idteachersmode_reserva_salon',
          'id_teachersmode_reserva_salon',
          'idteachersmode_reserva',
          'id_reserva',
        ]
        for (let i = 0; i < keys.length; i++) {
          if (reserva[keys[i]] != null && reserva[keys[i]] !== '') return reserva[keys[i]]
        }
        return null
      },

      cancelarReservaSeleccionada() {
        if (!this.reservaSeleccionada) return
        const idReserva = this.idReservaDesdeRow(this.reservaSeleccionada)
        if (!idReserva) {
          this.validarErrorDirecto('No se encontró el identificador de la reservación para cancelarla.')
          return
        }
        const payload = {
          escuela: this.escuela,
          deleted: 1,
          activo: 0,
        }
        this.cancelandoReservaSeleccionada = true
        this.$http
          .put('teachersmode.put.reserva_salon/' + idReserva, payload)
          .then(() => {
            this.dialogLinkZoom = false
            this.reservaSeleccionada = null
            this.consultarReservasRango()
          })
          .catch((error) => {
            this.validarError(error.response && error.response.data ? error.response.data.message : error)
          })
          .finally(() => {
            this.cancelandoReservaSeleccionada = false
          })
      },
  
      consultarReservasRango() {
        if (!this.fechaReservaDesde || !this.fechaReservaHasta) {
          this.validarErrorDirecto('Indica fecha desde y hasta.')
          return
        }
        if (this.esFinSemanaFecha(this.fechaReservaDesde)) {
          this.ajustarFechaReservaDesde()
          return
        }
        if (this.fechaReservaDesde > this.fechaReservaHasta) {
          this.fechaReservaHasta = this.fechaReservaDesde
        }
        if (!this.salonesConServidorList.length) {
          this.validarErrorDirecto('No hay salones con «Servidor» configurado para listar.')
          return
        }
        this.cargandoReservasRango = true
        this.consultaReservasEjecutada = true
        this.$http
          .get(
            'teachersmode.get.reservas_salones_rango/' +
              this.escuela +
              '/' +
              this.fechaReservaDesde +
              '/' +
              this.fechaReservaHasta
          )
          .then((response) => {
            const raw = response.data.reservas || response.data.items || response.data
            const gf = extraerGrupoFechasDesdeResponse(response.data)
            this.grupoFechas = gf.map((row) => {
              const hi = horaInicioDesdeRow(row)
              const hf = horaFinDesdeRow(row)
              const fe = fechaDesdeRowGrupo(row)
              const idNorm = idSalonDesdeRow(row)
              return {
                ...row,
                fecha: fe,
                hora_inicio: hi,
                hora_fin: hf,
                hora_final: hf,
                id_salon: idNorm != null ? idNorm : row.id_salon,
              }
            })
            this.reservasRango = Array.isArray(raw)
              ? raw.map((row) => {
                  const idNorm = idSalonDesdeRow(row)
                  const hi = horaInicioDesdeRow(row)
                  const hf = horaFinDesdeRow(row)
                  return {
                    ...row,
                    id_salon: idNorm != null ? idNorm : row.id_salon,
                    fecha: formatFechaYYYYMMDD(row.fecha),
                    hora_inicio: hi,
                    hora_fin: hf,
                    hora_final: hf,
                  }
                })
              : []
            this.rangoReservasConsulta = {
              desde: this.fechaReservaDesde,
              hasta: this.fechaReservaHasta,
            }
            this.tabDiaReserva = 0
          })
          .catch(() => {
            this.reservasRango = []
            this.grupoFechas = []
            this.rangoReservasConsulta = {
              desde: this.fechaReservaDesde,
              hasta: this.fechaReservaHasta,
            }
          })
          .finally(() => {
            this.cargandoReservasRango = false
          })
      },
  
      cargarSalones() {
        this.cargar = true
        this.salones = []
        return this.$http
          .get('salones.list')
          .then((response) => {
            this.salones = response.data || []
          })
          .catch((error) => {
            this.validarError(error.response && error.response.data ? error.response.data.message : error)
          })
          .finally(() => {
            this.cargar = false
          })
      },

      cargarFestivos() {
        return this.$http
          .get('festivos.list')
          .then((response) => {
            const rowsFestivos = Array.isArray(response.data) ? response.data : []
            this.festivos = (rowsFestivos || []).map((row) => ({
              idfestivos: row.idfestivos,
              festivo: row.festivo != null ? String(row.festivo) : '',
              fecha: formatFechaYYYYMMDD(row.fecha),
            }))
          })
          .catch(() => {
            this.festivos = []
          })
      },
  
      
    },
  }
  </script>
  
  <style scoped>
  .bloque-col {
    min-width: 130px;
  }
  .salon-col {
    min-width: 100px;
  }
  .teacher-reserva-chip.v-chip {
    height: auto !important;
    min-height: 22px;
    font-size: 0.7rem;
    padding: 0 6px;
  }
  .teacher-chip-click {
    cursor: pointer;
  }
  </style>
  